export default {
  timeFormats: {
    DATE: "Exact date range",
    TODAY: "Today",
    YESTERDAY: "Yesterday",
    LAST_7: "Last 7 days",
    LAST_30: "Last 30 days",
    THIS_MONTH: "This month",
    LAST_MONTH: "Last month",
    THIS_YEAR: "This year",
    LAST_YEAR: "Last year"
  },
  BF2: "BF2",
  BF3: "BF3",
  BF3_PLUS: "BF3+",
  BF4: "BF4",
  VLM: "VLM",
  KRS_CDiG: "CEIDG",
  FILE: "File"
};
